import React from 'react'

export const IconSearch: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <mask
        id="mask0_108_30979"
        style={{ maskType: 'alpha' }}
        width="13"
        height="13"
        x="5"
        y="5"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M13.931 14.875A5.301 5.301 0 0110.666 16a5.34 5.34 0 01-5.333-5.333 5.34 5.34 0 015.333-5.333A5.34 5.34 0 0116 10.666a5.302 5.302 0 01-1.126 3.265l2.93 2.93-.942.944-2.931-2.931zm.735-4.208c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4z"
          clipRule="evenodd"
        ></path>
      </mask>
      <g mask="url(#mask0_108_30979)">
        <path d="M0 0H24V24H0z"></path>
      </g>
    </svg>
  )
}
